import { createSelector } from '@ngrx/store';

import { BaseState, getBaseState } from '../reducers';
import { TranslationState } from './translation.reducers';

export const getTranslationState = createSelector(
  getBaseState,
  (state: BaseState) => state.translations
);

export const getTranslationLoaded = createSelector(
  getTranslationState,
  (state: TranslationState) => state.loaded
);

export const getTranslationLoadedInformal = createSelector(
  getTranslationState,
  (state: TranslationState) => state.loadedInformal
);

export const getTranslationLoading = createSelector(
  getTranslationState,
  (state: TranslationState) => state.loading
);
